/**
 * Constants used throughout application
 */
export const constants = {
    projectFileExtension: ".vott",
    assetMetadataFileExtension: "-asset.json",
    exportFileExtension: "-export.json",
};
